import React from 'react';
import PropTypes from 'prop-types';
import SharedProgressBar from 'components/ProgressBar';
import Style from './ProgressBar.module.scss';

const ProgressBar = ({
  endDate = '',
  startDate = '',
  percentWatched = null,
  showLiveProgressBar = false,
}) => {
  const videoHasPercentWatched = typeof percentWatched === 'number' && percentWatched >= 0;
  const showProgressBar = videoHasPercentWatched || showLiveProgressBar;
  if (!showProgressBar) return null;

  return (
    <SharedProgressBar
      data-test="tile-progress-bar"
      endDate={endDate}
      percentWatched={percentWatched}
      startDate={startDate}
      theme={Style}
    />
  );
};

ProgressBar.propTypes = {
  endDate: PropTypes.string,
  startDate: PropTypes.string,
  percentWatched: PropTypes.number,
  showLiveProgressBar: PropTypes.bool,
};

export default ProgressBar;
